export default function RoadMapLoader() {
  return (
    <div className="min-h-screen bg-base-200 flex items-center justify-center p-8 relative">
      <div className="w-full max-w-4xl mx-auto bg-base-100 rounded-xl p-8 shadow-xl border border-base-300 relative flex justify-center items-center flex-col gap-5">
        <p className="text-center font-bold text-3xl">Fetching Your RoadMap</p>
        <div className="w-full flex flex-col gap-3">
          {Array.from({ length: 4 }).map((_, index) => (
            <div
              key={index}
              className="w-full h-14 bg-base-100 animate-pulse rounded-md border border-base-300 shadow-sm"
            ></div>
          ))}
        </div>
        <p className="text-center text-md">This might take few mins kindly wait</p>
      </div>
    </div>
  );
}